import styled from 'styled-components';

export const OccurrenceName = styled.p`
  display: flex;
  flex-direction: row;
  align-items: left;
  justify-content: left;
  margin: 0;
`;

export const Occurrence = styled.span`
  text-align: right;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
  padding-right: 10px;
  padding-top: 2px;
`;
